import { loadState, saveState } from '../../../libs/persist';

const STORE_KEY = 'product';
var loaded = loadState(STORE_KEY) || {};

const state = {
	selectedInsuranceClass: loaded.selectedInsuranceClass || null,
	selectedProduct: loaded.selectedProduct || null,
	coverType: loaded.coverType || {},
	insuranceClass: loaded.insuranceClass || [],
	productCharges: loaded.productCharges || [],
};

const mutations = {
	SET_SELECTED_INSURANCE_CLASS(state, product) {
		state.selectedInsuranceClass = product;
		saveState(STORE_KEY, state);
	},
	SET_SELECTED_PRODUCT(state, product) {
		state.selectedProduct = product;
		saveState(STORE_KEY, state);
	},
	SET_SELECTED_COVERTYPE(state, type) {
		state.coverType = type;
		saveState(STORE_KEY, state);
	},
	SET_SELECTED_CLASS(state, data) {
		state.insuranceClass = data;
		saveState(STORE_KEY, data);
	},
	SET_PRODUCT_CHARGES(state, data) {
		state.productCharges = data;
		saveState(STORE_KEY, data);
	},
};

const actions = {
	setProduct({ commit }, product) {
		commit('SET_SELECTED_PRODUCT', product);
	},
	setClass({ commit }, product) {
		commit('SET_SELECTED_INSURANCE_CLASS', product);
	},
	setCoverType({ commit }, type) {
		commit('SET_SELECTED_COVERTYPE', type);
	},
	setInsuranceClass({ commit }, data) {
		commit('SET_SELECTED_CLASS', data);
	},
	setProductCharges({ commit }, data) {
		commit('SET_PRODUCT_CHARGES', data);
	},
};

const getters = {
	selectedClass: (state) => state.selectedInsuranceClass,
	selectedProduct: (state) => state.selectedProduct,
	selectedCoverType: (state) => state.coverType,
	selectInsuranceClass: (state) => state.insuranceClass,
	getProductCharges: (state) => state.productCharges,
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
